import React, { memo } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {    faCalendar, 
            faClock, 
            faMap } from '@fortawesome/free-regular-svg-icons';
import {    getRessouresUrl, 
            ellipsify, 
            prettyPrintDuration,
            cleanDisplayFilename } from '../../utils/config';

import PdfViewerModal from '../../components/pdf-viewer/PdfViewerModal';
import ImageGallery from 'react-image-gallery';

import '@react-pdf-viewer/core/lib/styles/index.css';
import './../../assets/css/image-gallery.scss';
import './../../assets/css/style.css';


const EventCard = (props) => {
    const event = props.data;
    
    return (
        <div className="custom-card viewer card-shadow">
            <div className="text-container">
                {/* Title */}
                <h3>
                    { event.title }
                </h3>
                <hr />
                <div className="pb-3">
                    {/* Start - end dates */}
                    <p>
                        <FontAwesomeIcon className="important-title" icon={faCalendar} />
                        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                        { prettyPrintDuration(event.eventStartDate, event.eventEndDate) }
                    </p>
                    {/* Start - end time */}
                    <p>
                        <FontAwesomeIcon className="important-title" icon={faClock} />
                        &nbsp;&nbsp;&nbsp;
                        from { (new Date("2000-01-01 "+event.eventStartTime)).toLocaleTimeString([], {hour: '2-digit', minute: '2-digit'}) } to { (new Date("2000-01-01 "+event.eventEndTime)).toLocaleTimeString([], {hour: '2-digit', minute: '2-digit'}) }
                    </p>
                    {/* Address */}
                    <p>
                        <FontAwesomeIcon className="important-title" icon={faMap} />
                        &nbsp;&nbsp;&nbsp;&nbsp;
                        {event.address}
                    </p>
                </div>
                {/* Description */}
                {
                    event.description
                    ?   <p className="p-reading-text">
                            { event.description }
                        </p>
                    : null
                }
                {/* Uploaded documents and files */}
                {
                    event.eventDocs.length !== 0
                    ?   <div key={event._id+event.title+"docs"}>
                            <p className="p-tiny-text pt-4">
                                Documents & files
                            </p>
                            {event.eventDocs.map((doc, index) => (
                                <div key={cleanDisplayFilename(doc)+index}>
                                    <PdfViewerModal btnPrompt={cleanDisplayFilename(doc)}
                                                    modalPrompt={cleanDisplayFilename(doc)} 
                                                    ressource={getRessouresUrl()+doc}/>
                                    {index !== (event.eventDocs.length-1)
                                        ? <span><br /></span>
                                        : null
                                    }
                                </div>
                            ))}
                        </div>
                    : null
                }
                {/* Links and ressources */}
                {
                    event.links.length !== 0
                    ?   <div>
                            <p className="p-tiny-text pt-4">
                                Links and ressources
                            </p>
                            {event.links.map((data, index) => (
                                <span key={data.link+index}>
                                    <a  target="_blank" 
                                        rel="noreferrer" 
                                        draggable={false}
                                        href={data.link} >
                                            {data.display
                                                ? data.display
                                                : ellipsify(data.link)
                                            }
                                    </a>    
                                    {index !== (event.links.length-1)
                                        ? <span>, </span>
                                        : null
                                    }
                                </span>
                            ))}
                        </div>
                    : null
                }
                {/* Uploaded images */}
                {
                    event.eventImages.length !== 0
                    ? <>
                        <br />
                        <ImageGallery items={
                            event.eventImages.map(img => ({
                                original: getRessouresUrl()+img,
                                thumbnail: getRessouresUrl()+img,
                                originalHeight: 400,
                                thumbnailHeight: 30,
                            }))}
                            showNav={true}
                            showThumbnails={event.eventImages.length > 1}
                            showFullscreenButton={false}
                            showPlayButton={false}
                            autoPlay={false}
                        />
                    </>
                    : null
                }
            </div>
        </div>);

};

export default memo(EventCard);
